import { Button } from 'components/ui/button'
import { Download, X, Plus, RotateCw, Trash2 } from 'lucide-react'
import { useTasks } from '../context/tasks-context'

export const TasksPrimaryButtons: React.FC = () => {
  const { setOpen } = useTasks()
  return (
    <div className='flex gap-2'>
      <Button className='space-x-1' onClick={() => setOpen('import')}>
        <span>Carica</span> <Download size={18} />
      </Button>

      <Button
        variant='outline'
        className='space-x-1'
        onClick={() => setOpen('restart-server')}
      >
        <span>Restart server</span> <RotateCw size={18} />
      </Button>
      <Button
        variant='outline'
        className='space-x-1'
        onClick={() => setOpen('clean-cache')}
      >
        <span>Clean cache</span> <X size={18} />
      </Button>
      <Button
        variant='destructive'
        className='space-x-1'
        onClick={() => setOpen('flush-cache')}
      >
        <span>Svuota tutta la cache</span> <Trash2 size={18} />
      </Button>
      <Button className='space-x-1' onClick={() => setOpen('create')}>
        <span>Run Job</span> <Plus size={18} />
      </Button>
    </div>
  )
}
